import OpenQuestion from "./OpenQuestion";

export default OpenQuestion;
